export const AdminFeatures = {
  ADMIN_PLUGINS: 'ADMIN_PLUGINS',
  ADVANCED_REPORTING: 'ADVANCED_REPORTING',
  // TODO: Re-enable when billing v2 is ready
  // BILLING_V2: 'BILLING_V2',
};

export const CoreFeatures = {
  HOST_LIMIT: 'HOST_LIMIT',
  PRIVATE_HOSTS: 'PRIVATE_HOSTS',
  ADDITIONAL_BADGES: 'ADDITIONAL_BADGES',
  WORKPLACE_EXPERIENCES: 'WORKPLACE_EXPERIENCES',
  ZONES: 'ZONES',
  LOBBY_MODE: 'LOBBY_MODE',
  OUTLOOK_ADDIN: 'OUTLOOK_ADDIN',
  PUBLIC_API: 'PUBLIC_API',
  ELASTICSEARCH: 'ELASTICSEARCH',
  CHECKLISTS_IDENTIFIER: 'CHECKLISTS_IDENTIFIER',
  ADVANCED_CHECKLISTS: 'ADVANCED_CHECKLISTS',
  CORE: 'CORE',
};

export const WorkflowsFeatures = {
  WORKFLOWS: 'WORKFLOWS',
  WORKFLOWS_SMS_ENABLED: 'WORKFLOWS_SMS_ENABLED',
  WORKFLOW_PERMITS: 'WORKFLOW_PERMITS',
};

export const CompaniesFeatures = {
  CONNECT_WORKFLOWS_INTEGRATION: 'CONNECT_WORKFLOWS_INTEGRATION',
  CONNECT_COMPANY_DOCUMENTS: 'CONNECT_COMPANY_DOCUMENTS',
};

export const ProductFeatures = {
  Admin: Object.values(AdminFeatures),
  Core: Object.values(CoreFeatures),
  Workflows: Object.values(WorkflowsFeatures),
  Companies: Object.values(CompaniesFeatures),
};

export const featureNotes: Record<string, string> = {
  'Advanced Checklists': 'This feature should only be enabled for Teams with Medium Sites.',
};
